(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ttt-brand-home"] && !Shopify.designMode) return;
  try {
    
  const initializeTeaCarousels = () => {
    document.querySelectorAll('.ttt-product-carousel').forEach(track => {
      if (track.dataset.initialized) return;
      track.dataset.initialized = 'true';
      const buttons = [...track.closest('.ttt-featured').querySelectorAll('[data-ttt-carousel-step]')];
      const update = () => buttons.forEach(button => {
        const end = track.scrollWidth - track.clientWidth;
        button.disabled = Number(button.dataset.tttCarouselStep) < 0 ? track.scrollLeft < 5 : track.scrollLeft >= end - 5;
      });
      const move = direction => track.scrollBy({left: direction * track.clientWidth * .85, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      buttons.forEach(button => button.addEventListener('click', () => move(Number(button.dataset.tttCarouselStep))));
      track.addEventListener('scroll', update, {passive: true});
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      });
      new ResizeObserver(update).observe(track);
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeTeaCarousels);
  else initializeTeaCarousels();
  document.addEventListener('shopify:section:load', initializeTeaCarousels);
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-ttt-open-quiz]');
    if (trigger) document.getElementById(trigger.dataset.tttOpenQuiz)?.showModal();
    const closer = event.target.closest('[data-ttt-close-quiz]');
    if (closer) closer.closest('dialog')?.close();
    if (event.target.matches('dialog.ttt-quiz-dialog')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
